<template lang="pug">
    .event-tabs(v-if="enabledExtensions.includes('event-manager')")
        tabs(:items="tabs" :active-tab="$route.fullPath" @click="activateTab")
        slot
    .full-height-error(v-else)
        Error(:message="null" :code="403")
</template>

<i18n>
{
    "de": {
        "Events": "Events",
        "Bookings": "Anmeldungen",
        "Categories": "Kategorien",
        "Registration forms": "Anmeldeformulare"
    }
}
</i18n>

<script>
import { useSetupStore } from '@/stores';
import Tabs from '@/components/Tabs';
import Error from '@/components/Error';

export default {
    name: 'EventManagerTabs',
    components: {
        Tabs,
        Error
    },
    computed: {
        tabs() {
            const tabs = [
                {
                    name: this.$t('Events'),
                    path: '/event-manager/events',
                    icon: {
                        name: 'calendar-alt',
                        group: 'fas'
                    }
                },
                {
                    name: this.$t('Categories'),
                    path: '/event-manager/categories',
                    icon: {
                        name: 'folder',
                        group: 'far'
                    }
                },
                {
                    name: this.$t('Bookings'),
                    path: '/event-manager/bookings',
                    icon: {
                        name: 'calendar-check',
                        group: 'far'
                    }
                },
            ];

            // Configurable registration forms are a storefront feature (citystore-ssr) - other
            // templates render the fixed registration form only.
            if (this.hasRegistrationTemplates) {
                tabs.push({
                    name: this.$t('Registration forms'),
                    path: '/event-manager/registration-templates',
                    icon: {
                        name: 'clipboard-list',
                        group: 'fas'
                    }
                });
            }

            return tabs;
        },
        hasRegistrationTemplates() {
            return useSetupStore().enabledFeatures.includes('event-manager:registration-templates');
        },
        enabledExtensions() {
            return useSetupStore().enabledExtensions;
        },
        setupStore() {
            return useSetupStore();
        }
    },
    methods: {
        activateTab(item) {
            return this.setupStore.activateTab(item);
        }
    }
};
</script>
